/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierProBlockAccountInput
 */
export interface CarrierProBlockAccountInput {
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockAccountInput
   */
  carrierProBlockId: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockAccountInput
   */
  newCarrierAccountNumber?: string | null;
}

/**
 * Check if a given object implements the CarrierProBlockAccountInput interface.
 */
export function instanceOfCarrierProBlockAccountInput(
  value: object,
): value is CarrierProBlockAccountInput {
  if (
    !("carrierProBlockId" in value) ||
    value["carrierProBlockId"] === undefined
  )
    return false;
  return true;
}

export function CarrierProBlockAccountInputFromJSON(
  json: any,
): CarrierProBlockAccountInput {
  return CarrierProBlockAccountInputFromJSONTyped(json, false);
}

export function CarrierProBlockAccountInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierProBlockAccountInput {
  if (json == null) {
    return json;
  }
  return {
    carrierProBlockId: json["carrierProBlockId"],
    newCarrierAccountNumber:
      json["newCarrierAccountNumber"] == null
        ? undefined
        : json["newCarrierAccountNumber"],
  };
}

export function CarrierProBlockAccountInputToJSON(
  json: any,
): CarrierProBlockAccountInput {
  return CarrierProBlockAccountInputToJSONTyped(json, false);
}

export function CarrierProBlockAccountInputToJSONTyped(
  value?: CarrierProBlockAccountInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierProBlockId: value["carrierProBlockId"],
    newCarrierAccountNumber: value["newCarrierAccountNumber"],
  };
}
